module.exports = __webpack_public_path__ + "assets/chevronRight-58b184.svg";